/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  connectGoogleAccount,
  disconnectGoogleAccount,
} from '../../../../profile/ducks/profileActions';
import { fetchUserData } from '../../../../login/ducks/loginActions';

import Text from '../../../../../shared/_TBComponents/Text';
import theme from '../../../../../shared/theme/theme';
import GoogleImage from '../../../../../shared/images/google-2015-logo.png';

const Image = styled('img')`
  width: 116px;
`;

const HeaderContainer = styled('div')`
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: #E0E0E0 1px solid;

`;

// eslint-disable-next-line react/prop-types
const DisconnectButton = ({ disconnect }) => (
  <div
    role='button'
    tabIndex={0}
    style={{
      borderRadius: 5,
      height: 45,
      width: 200,
      alignItems: 'center',
      backgroundColor: theme.colors.red,
      display: 'flex',
      justifyContent: 'center',
    }}
    onClick={disconnect}
  >
    <Text color='white' fontSize={20} fontWeight='800'>
      Disconnect
    </Text>
  </div>
);

const SingleSignOn = ({ containerWidth }) => {
  const dispatch = useDispatch();
  const me = useSelector((state) => state.auth.data.currentUser);

  const disconnectGoogle = () => {
    dispatch(disconnectGoogleAccount());
    dispatch(fetchUserData());
  };

  const handleGoogleResponse = async (credentialResponse) => {
    const tokenId = credentialResponse.credential;

    if (!tokenId) {
      return;
    }

    dispatch(
      connectGoogleAccount({
        googleId: tokenId,
      }),
    );
    setTimeout(() => dispatch(fetchUserData()), 800);
  };

  const render = () => (
    <>
      <HeaderContainer>
        <Text styledTextProps={{ fontSize: containerWidth && containerWidth < 400 ? '24px' : '28px', fontWeight: '700' }}>
          Single Sign On
        </Text>
        <Text styledTextProps={{ fontSize: '18px', fontWeight: '400' }}> Manage alternative ways to sign in to the TeamBuildr platform.</Text>
      </HeaderContainer>

      <div style={{
        alignItems: 'center',
        borderBottomColor: theme.colors.noBorderColor,
        borderBottomWidth: 1,
        display: 'flex',
        flexDirection: containerWidth && containerWidth < 545 ? 'column' : 'row',
        height: containerWidth && containerWidth < 545 ? 'auto' : 70,
        justifyContent: 'space-between',
      }}
      >
        <Image alt='Google' src={GoogleImage} />
        {Object.keys(me?.userSettings?.google).length ? (
          <DisconnectButton disconnect={disconnectGoogle} />
        ) : (
          <div style={{ width: 300, marginLeft: 10 }}>
            <GoogleLogin
              locale='en'
              onSuccess={handleGoogleResponse}
              text='signin_with'
              width='300'
            />
          </div>
        )}
      </div>
    </>
  );

  return (
    <div style={{
      display: 'flex',
      marginBottom: 20,
      flexDirection: 'column',
      width: '100%',
    }}
    >
      {Object.keys(me).length && render()}
    </div>
  );
};

SingleSignOn.propTypes = {
  containerWidth: PropTypes.number,
};

SingleSignOn.defaultProps = {
  containerWidth: '',
};

export default SingleSignOn;
